<template>
  <div class="topping-list-form">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <div class="form-group row header-custom-switch">
            <div class="col-sm-10 col-form-label uppercase">
              <strong>
                <h3>
                  <router-link :to="{ name: 'outlets_edit',  params: { uuid: uuid }}" class="float-left mr-1 main-link">{{$t('store.outlets')}}</router-link>
                  <span class="float-left mr-1 main-link">/</span>
                  <router-link :to="{ name: 'menu_control',  params: { uuid: uuid }}" class="float-left mr-1 main-link">{{$t('store.menu_control')}}</router-link>
                  / {{$t('store.topping_exclusion_editing')}}
                </h3>
              </strong>
            </div>

          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-card class="mb-0">
            <div slot="header">
              <strong class="text-uppercase">
                {{$t('store.topping_exclusion_editing')}}
              </strong>
            </div>

            <b-row>
              <b-col cols="12" class="text-center">
                <!-- Start of Filter session -->
                <b-row class="mb-3">
                  <b-col xl="12">
                    <div class="pull-right mr-2">
                      <b-input-group v-bind:prepend="$t('common.data_only_lunch')">
                        <b-form-select v-model="filter.only_lunch" v-bind:value="filter.only_lunch"
                                       :options="only_lunch_statuses[$session.get('lang')]"
                                       v-bind:placeholder="$t('common.data_only_lunch')">
                        </b-form-select>
                      </b-input-group>
                    </div>
                    <div class="pull-right mr-2">
                      <b-input-group v-bind:prepend="$t('topping.type')">
                        <b-form-select v-model="filter.type" v-bind:value="filter.type"
                                       :options="type_statuses[$session.get('lang')]"
                                       v-bind:placeholder="$t('topping.type')">
                        </b-form-select>
                      </b-input-group>
                    </div>
                    <div class="pull-right mr-2">
                      <b-input-group v-bind:prepend="$t('topping.special')">
                        <b-form-select v-model="filter.special" v-bind:value="filter.special"
                                       :options="special_statuses[$session.get('lang')]"
                                       v-bind:placeholder="$t('topping.special')">
                        </b-form-select>
                      </b-input-group>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col xl="6">
                    <div class="pull-right mr-2">
                      <b-input-group v-bind:prepend="$t('topping.active')">
                        <b-form-select v-model="filter.active"
                                       v-bind:value="filter.active"
                                       :options="statuses[$session.get('lang')]"
                                       v-bind:placeholder="$t('topping.active')">
                        </b-form-select>
                      </b-input-group>
                    </div>
                  </b-col>
                  <b-col xl="6">
                    <b-input-group>
                      <select-dropdown v-bind:options="filter.options"
                                       v-bind:selected="filter.selected"
                                       position="prepend"
                                       v-bind:all="false"
                                       v-model="filter.field"
                                       prefix="topping">
                      </select-dropdown>
                      <input type="text" class="form-control" v-model="filter.key" v-on:keydown.enter="refreshData"/>
                      <div class="input-group-append">
                        <b-input-group-append>
                          <b-btn @click="refreshData()"><i class="fa fa-search"></i>
                            {{$t('common.search')}}
                          </b-btn>
                        </b-input-group-append>
                      </div>
                    </b-input-group>
                  </b-col>
                </b-row>
                <!-- End of Filter session -->

                <!-- Start of Data table session -->
                <div class="table-responsive single-data">
                  <table class="table table-striped table-hover table-sm table-bordered">
                    <thead>
                    <tr>
                      <th scope="col"> {{$t('store.exclusion_target')}}</th>
                      <th scope="col" v-for="item in dataTable.fields" :key="item.id"
                          @click="updateSort(item.name)" :class="item.sort?'pointer':''">
                        <i class="fa fa-sort-amount-asc text-muted"
                           v-if="dataTable.sort.type === 'asc' && dataTable.sort.field === item.name"></i>
                        <i class="fa fa-sort-amount-desc text-muted"
                           v-if="dataTable.sort.type === 'desc' && dataTable.sort.field === item.name"></i>
                        <span v-if="item.label != null">{{$t('topping.'+item.label)}}</span>
                        <span v-if="item.label == null">{{$t('topping.'+item.name)}}</span>
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-if="dataTable.items.length === 0">
                      <td class="text-center" :colspan="dataTable.fields.length + 5">
                        {{$t('message.no_data')}}
                      </td>
                    </tr>
                    <tr v-for="item in dataTable.items" :key="item.id">
                      <td scope="row">
                        <b-form-checkbox class="checkbox-warning" v-model="item.value" value="1" unchecked-value="0"></b-form-checkbox>
                      </td>
                      <td scope="row" class="text-left" v-for="field in dataTable.fields" :key="field.id">
                        <span v-if="field.render != null" v-html="field.render(item[field.name], item)"></span>
                        <span v-if="field.render == null">{{item[field.name]}}</span>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                <!-- End of Data table session -->

                <!-- Start of paginate session -->
                <b-row>
                  <b-col>
                    <b-pagination :total-rows="dataTable.total" :per-page="dataTable.perPage"
                                  v-model="dataTable.currentPage"/>
                  </b-col>
                  <b-col class="text-left">
                    {{$t('message.datatable_total', {number: dataTable.items.length, total:
                    dataTable.total})}}
                  </b-col>
                  <b-col col lg="1">
                    <b-form-select v-model="dataTable.perPage" :options="[10, 20, 50, 100]"
                                   class="mb-3"/>
                  </b-col>
                </b-row>
                <!-- Start of paginate session -->
              </b-col>
            </b-row>
            <div slot="footer">
              <button type="button" class="btn border-radius-4px bg-main float-left ml-4" @click="$router.back()"><i class="fa fa-arrow-left"></i> {{$t('common.back')}}</button>
              <div class="btn-save">
                <button type="button" class="btn bg-main border-radius-4px pl-3 pr-3" v-if="isShowPublishButton" v-on:click="publishAll()"> {{$t('common.publish')}}
                </button>
                <span v-if="!isShowPublishButton" style="padding-right: 20px; font-weight: bold;" > {{$t('common.publishing')}} ... </span>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import SelectDropdown from '../../../components/Partials/SelectDropdown'
  let vm = null

  export default {
    name: 'ToppingExclusionForm',
    components: {
      SelectDropdown,
    },
    props: {
      uuid: {
        type: String,
        required: true,
        default: 'create'
      }
    },
    data: function () {
      return {
        is_using_menu_v4_api: false,
        outletInfo: { code: '', name: {}, description: {}, address: '' },
        allSelected: false,
        statuses: [],
        only_lunch_statuses: [],
        type_statuses: [],
        special_statuses: [],
        filter: {
          options: [],
          active: 1,
          status: '',
          only_lunch: '',
          special: '',
          type: '',
          name: '',
          field: null,
          key: null,
          aggregator_code: '',
        },
        dataTable: {
          items: [],
          fields: [
            {
              name: 'sku',
              label: 'sku',
              filter: true,
              sort: true,
              render: (data) => {
                return data
              }
            },
            {
              name: 'name',
              label: 'name',
              filter: true,
              sort: true,
              render: (data) => {
                if (data == null) {
                  return ''
                }
                return data[this.$session.get('lang')]
              }
            },
          ],
          sort: {
            field: 'updated_at',
            type: 'desc'
          },
          currentPage: 1,
          total: 0,
          perPage: 20,
          source: null
        },
        isShowPublishButton: false
      }
    },
    created () {
      if(this.$store.getters.config.gms.outlet.config.show_menu_out_of_stock){
        this.$router.push({path: '/outlets/outlet-out-of-stock/topping-out-of-stock/' + this.$route.params.uuid});
      }
      this.debouncedInput = _.debounce(this.refreshData, 240)
      vm = this
      for (let i in vm.dataTable.fields) {
        if (!vm.dataTable.fields.hasOwnProperty(i)) continue
        let field = vm.dataTable.fields[i].name
        if (vm.dataTable.fields[i].filter != null && vm.dataTable.fields[i].filter === true) {
          vm.filter.options.push(vm.dataTable.fields[i])
        }
        if (vm.dataTable.fields[i].sort != null && vm.dataTable.fields[i].sort === true && vm.dataTable.sort.field == null) {
          vm.dataTable.sort = {
            field: field,
            type: 'asc'
          }
        }
      }
      vm.$Progress.start()
      vm.getStatusData()
      let filter = this.$session.get('filter', null)
      if (filter != null && this.$route.query && this.$route.query.rollback) {
        for (let i in filter.filter) {
          if (!filter.filter.hasOwnProperty(i)) continue
          this.filter[i] = filter.filter[i]
        }
        for (let i in filter.dataTable) {
          if (!filter.dataTable.hasOwnProperty(i)) continue
          this.dataTable[i] = filter.dataTable[i]
        }
      }

      this.axios.outlet.getOutletDetail(this.$route.params.uuid,
        function (response) {
          const config = vm.$session.get('config')
          const manualConfig = vm._.get(config, 'manual_config', {}) || {}

          let item = response.data.data.item

          const isUsingMenuV4Api = (manualConfig.use_menu_v4_api_stores ? manualConfig.use_menu_v4_api_stores.split(',') : []).includes(item.code)
          vm.is_using_menu_v4_api = isUsingMenuV4Api
          console.log('is_using_menu_v4_api_topping_exclusion', vm.is_using_menu_v4_api)

          vm.$set(vm.outletInfo, 'id', item.id)
          vm.$set(vm.outletInfo, 'code', item.code)
          vm.$set(vm.outletInfo, 'name', item.name ? item.name : {})
          vm.$set(vm.outletInfo, 'description', item.description ? item.description : {})
          vm.$set(vm.outletInfo, 'address', item.address)
          if (vm.$store.getters.config.gms.outlet.config.show_push_to_prod) {
            vm.checkShowPublishButton()
          } else {
            vm.isShowPublishButton = true
          }
          vm.refreshData()
        })
    },
    methods: {
      async publishAll () {
        let data = {
          outlet_code: this.outletInfo.code,
          layers: this.dataTable.items.map(item => {
            item.uuid = 'topping_' + item.id
            return item
          })
        }
        vm.isShowPublishButton = true
        if (vm.$store.getters.config.gms.outlet.config.show_push_to_prod) {
          vm.isShowPublishButton = false
          let time = Number(vm.$store.getters.config.manual_config.set_time_show_button_push_to_prod_store)
          time = Number.isNaN(time) ? 5 : time 
          vm.setCacheLocalStorage(  this.outletInfo.code + '_' + 'pushlish', true, time )
        }
        vm.axios.menu.saveMenuControl(data, function (response) {
          vm.$toastr.success(vm.$t('message.success'), vm.$t('message.success'), {})
          const menuParams = {
            'scope': 'all',
            'outlet': {
              'uuid': vm.$route.params.uuid,
              'code': vm.outletInfo.code
            },
          }
          if (!vm.is_using_menu_v4_api || vm.is_using_menu_v4_api === false) {
            menuParams.publish_pizza = 1
          }
          vm.axios.menu.publishMenu(menuParams)

          vm.axios.menu.publishCombo({
            'scope': 'all',
            'outlet': {
              'uuid': vm.$route.params.uuid,
              'code': vm.outletInfo.code
            }
          })
        }, function (data) {
          vm.$toastr.error(vm.$t('message.error'), vm.$t('message.success'), {})
        })
      },
      checkShowPublishButton() {
        let getCache = vm.getCacheLocalStorage(vm.outletInfo.code + '_' + 'pushlish')
        vm.isShowPublishButton = true
        if (!getCache.expired) {
          vm.isShowPublishButton = false
        } 
      },
      /**
       * update sort field and sort type then refresh data
       * @param field
       */
      updateSort (field) {
        for (let i in this.dataTable.fields) {
          if (!this.dataTable.fields.hasOwnProperty(i)) continue
          if (this.dataTable.fields[i].name === field && (this.dataTable.fields[i].sort == null || this.dataTable.fields[i].sort === false)) {
            return
          }
        }
        if (this.dataTable.sort.field !== field) {
          this.dataTable.sort = {
            field: field,
            type: 'asc'
          }
        } else {
          if (this.dataTable.sort.type === 'asc') {
            this.dataTable.sort = {
              field: field,
              type: 'desc'
            }
          } else {
            this.dataTable.sort = {
              field: field,
              type: 'asc'
            }
          }
        }

        this.refreshData()
      },
      /**
       * refresh data for data table
       */
      refreshData () {
        //get params
        let _data = {
          page: this.dataTable.currentPage,
          limit: this.dataTable.perPage,
          sort_field: this.dataTable.sort.field,
          sort_type: this.dataTable.sort.type
        }
        if (String(this.filter.active) !== '') {
          _data['active'] = this.filter.active
        }

        if (String(this.filter.only_lunch) !== '') {
          _data['only_lunch'] = this.filter.only_lunch
        }

        if (String(this.filter.type) !== '') {
          _data['type'] = this.filter.type
        }

        if (String(this.filter.special) !== '') {
          _data['special'] = this.filter.special
        }

        if (!this._.isEmpty(this.filter.field) && !this._.isEmpty(this.filter.key)) {
          _data[this.filter.field] = this.filter.key.trim()
        }

        _data['outlet_code'] = this.outletInfo.code
        //process to send via get method
        let params = ''
        for (let key in _data) {
          params += key + '=' + _data[key] + '&'
        }
        //remove tail
        params = params.slice(0, -1)

        vm.axios.menu.getToppingExclusionList(params, function (response) {
          vm.dataTable.items = response.data.data.items
          vm.dataTable.total = response.data.data.total
          this.$forceUpdate()
        })
      },
      /**
       * get list categories for select box
       */
      getStatusData () {
        let langs = Object.keys(vm.$i18n.messages)
        for (let l in langs) {
          vm.only_lunch_statuses[langs[l]] = [
            {text: vm.$t('common.all', langs[l]), value: ''},
            {text: vm.$t('common.only_lunch', langs[l]), value: 1},
            {text: vm.$t('common.non_only_lunch', langs[l]), value: 0}
          ]
          vm.statuses[langs[l]] = [
            {text: vm.$t('common.all', langs[l]), value: ''},
            {text: vm.$t('common.active', langs[l]), value: '1'},
            {text: vm.$t('common.inactive', langs[l]), value: '0'}
          ]
          vm.type_statuses[langs[l]] = [
            {text: vm.$t('common.all', langs[l]), value: ''},
            {text: vm.$t('topping.type_all', langs[l]), value: 0},
            {text: vm.$t('topping.type_default', langs[l]), value: 1},
            {text: vm.$t('topping.type_extra', langs[l]), value: 2}
          ]
          vm.special_statuses[langs[l]] = [
            {text: vm.$t('common.all', langs[l]), value: ''},
            {text: vm.$t('common.yes', langs[l]), value: 1},
            {text: vm.$t('common.no', langs[l]), value: 0}
          ]
        }
      }
    },
    watch: {
      'filter.key': function () {
        this.debouncedInput()
      },
      'dataTable.currentPage': function () {
        vm.refreshData()
      },
      'dataTable.perPage': function () {
        vm.refreshData()
      },
      'filter.active': function () {
        vm.refreshData()
      },
      'filter.only_lunch': function () {
        vm.refreshData()
      },
      'filter.type': function () {
        vm.refreshData()
      },
      'filter.special': function () {
        vm.refreshData()
      },
    }
  }
</script>

<style>
  .topping-list-form .btn-save{
    float: right;
    margin-right: 22px;
  }
  .topping-list-form .card-footer{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 7.75px;
    border-top: none;
    margin-top: 1.5rem;
    z-index: 999;
  }
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/views/admin/outlets/ToppingExclusionForm.vue